import { type PropsWithChildren } from 'react';

import type { ChartLoaderOverlayProps } from './types.js';
import { WheelZoomPreventer } from '../wheel-zoom-preventer/WheelZoomPreventer.js';

/**
 * @internal
 *
 * Prevents browser zoom if zoom interaction is enabled, otherwise nothing
 * happens.
 */
const ZoomPreventer = ({ zoomEnabled }: { zoomEnabled?: boolean }) =>
  zoomEnabled ? <WheelZoomPreventer /> : null;

/**
 * @internal
 *
 * Component used to decide if some actions should be done during charts
 * loading states.
 */
export const ChartLoaderOverlay = ({
  children,
  loading = false,
  zoomEnabled = false,
}: PropsWithChildren<ChartLoaderOverlayProps>) => {
  return loading ? <ZoomPreventer zoomEnabled={zoomEnabled} /> : children;
};

ChartLoaderOverlay['displayName'] = 'ChartLoaderOverlay';
